import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import BankAccountSalesOfficeAccountingAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/bank/bank-account/bank-account-sales-office-accounting/bank-account-sales-office-accounting.entity";
import { PayloadAccountSalesBasic } from "../../account-sales/interfaces/account-sales.interface";

const apiUrl = env.API_PAYMENT_MASTER_URL;
const moduleName = "bank_account_sales_office_accounting";

@Injectable({
  providedIn: "root",
})
export class BankAccountSalesOfficeService extends AbstractService<
    BankAccountSalesOfficeAccountingAttributes, 
    PayloadAccountSalesBasic,
    PayloadAccountSalesBasic> {

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    getAllList(bankId: string, bankAccountId: string): Observable<IAPIListResult<BankAccountSalesOfficeAccountingAttributes>> {
        const API_URL: string = apiUrl + `api/${moduleName}/${bankId}/${bankAccountId}`;
        return this.http.get<IAPIListResult<BankAccountSalesOfficeAccountingAttributes>>(API_URL);
    }
}
